import React from 'react';

const DragDropSvg = ({width = 20, height = 20, couleur = "#70787B"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 38"
         fill="none">
        <path d="M25.7177 7.81629V1.9082H2V25.5405H8.77649" stroke={couleur} strokeWidth="3"
              strokeDasharray="3 3"/>
        <path d="M21.8601 32.8101H10.0439V9.17773H33.6763V20.9939" stroke={couleur}
              strokeWidth="3"/>
        <path
            d="M29.2267 36.0919L21.9158 20.008L37.9998 27.3189L31.6637 29.7558L29.2267 36.0919Z"
            stroke={couleur} strokeWidth="2.5" strokeLinejoin="round"/>
    </svg>
);

export default DragDropSvg;
